/* B2B Tab Switching + Qty Stepper + Add to Cart – b2b-tabs.js */
(function () {

  /* ── Tab switching ── */
  function initTabs() {
    document.querySelectorAll('.b2b-tab').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var wrapper = tab.closest('.b2b-tabs');
        wrapper.querySelectorAll('.b2b-tab').forEach(function (t) { t.classList.remove('active'); });
        wrapper.querySelectorAll('.b2b-tab-content').forEach(function (c) { c.classList.remove('active'); });
        tab.classList.add('active');
        var content = wrapper.querySelector('[data-content="' + tab.dataset.tab + '"]');
        if (content) content.classList.add('active');
      });
    });
  }

  /* ── Qty Stepper ──
     Schrittweite = data-vpe (Rollenlänge bei Meterware, z. B. Einlegeschlauch 50 / ø 200: 25; sonst 1).
     Handeingaben rasten auf das Vielfache ein. */
  function vpeOf(input) { return parseInt(input.dataset.vpe, 10) || parseInt(input.step, 10) || 1; }
  function snapQty(input) {
    var vpe = vpeOf(input);
    var val = parseInt(input.value, 10) || vpe;
    var v = Math.max(vpe, Math.round(val / vpe) * vpe);
    if (String(v) !== input.value) input.value = v;
    return v;
  }
  function initSteppers() {
    document.querySelectorAll('.b2b-qty-stepper').forEach(function (stepper) {
      var input = stepper.querySelector('.b2b-qty-input');
      stepper.querySelector('.b2b-qty-minus').addEventListener('click', function () {
        var vpe = vpeOf(input);
        var val = parseInt(input.value, 10) || vpe;
        input.value = Math.max(vpe, val - vpe);
        snapQty(input);
      });
      stepper.querySelector('.b2b-qty-plus').addEventListener('click', function () {
        var vpe = vpeOf(input);
        var val = parseInt(input.value, 10) || vpe;
        input.value = val + vpe;
        snapQty(input);
      });
      input.addEventListener('change', function () { snapQty(input); });
    });
  }

  /* ── Update cart bubble + cart drawer after AJAX add ── */
  function refreshCart() {
    fetch('/?sections=cart-icon-bubble,cart-drawer', {
      headers: { 'Accept': 'application/json' }
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {

      /* 1. Bubble-Zähler aktualisieren */
      if (data['cart-icon-bubble']) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(data['cart-icon-bubble'], 'text/html');
        var newBubble = doc.querySelector('.cart-count-bubble');
        var existingBubble = document.querySelector('.cart-count-bubble');
        if (newBubble && existingBubble) {
          existingBubble.innerHTML = newBubble.innerHTML;
        } else if (newBubble) {
          var cartLink = document.querySelector('a[href="/cart"]');
          if (cartLink) cartLink.appendChild(newBubble.cloneNode(true));
        }
      }

      /* 2. Cart Drawer Inhalt aktualisieren */
      if (data['cart-drawer']) {
        var drawerParser = new DOMParser();
        var drawerDoc = drawerParser.parseFromString(data['cart-drawer'], 'text/html');
        var newDrawer = drawerDoc.getElementById('CartDrawer');
        var existingDrawer = document.getElementById('CartDrawer');
        if (newDrawer && existingDrawer) {
          existingDrawer.innerHTML = newDrawer.innerHTML;
        }
      }
    })
    .catch(function (e) { console.warn('[b2b-tabs] cart refresh failed:', e); });
  }

  /* ── Add to Cart ── */
  function initCartButtons() {
    document.querySelectorAll('.b2b-add-to-cart-btn[data-variant-id]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        if (btn.dataset.loading) return;

        var variantId = parseInt(btn.dataset.variantId, 10);
        var row = btn.closest('tr');
        var qtyInput = row ? row.querySelector('.b2b-qty-input') : null;
        var quantity = qtyInput ? snapQty(qtyInput) : 1;

        /* Lock gegen Doppelklick + sofort grün */
        btn.dataset.loading = '1';
        btn.style.background = '#3cb371';

        fetch('/cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Accept': 'application/json',
            'X-Requested-With': 'XMLHttpRequest'
          },
          body: JSON.stringify({ id: variantId, quantity: quantity })
        })
        .then(function (res) {
          if (!res.ok) {
            return res.json().then(function (err) {
              throw new Error(err.description || 'HTTP ' + res.status);
            });
          }
          return res.json();
        })
        .then(function () {
          btn.style.background = '#3cb371';
          btn.style.opacity = '1';
          refreshCart();
          setTimeout(function () {
            btn.style.background = '';
            delete btn.dataset.loading;
          }, 1400);
        })
        .catch(function (err) {
          console.error('[b2b-tabs] Add to cart error:', err);
          btn.style.background = '#e55';
          btn.style.opacity = '1';
          setTimeout(function () {
            btn.style.background = '';
            delete btn.dataset.loading;
          }, 1400);
        });
      });
    });
  }

  /* ── Init ── */
  function init() {
    initTabs();
    initSteppers();
    initCartButtons();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

})();
